const getters = {
  getDeviationFixerQueue: (state) => {
    return _.toArray(state.deviationFixerQueue);
  },

}

export default getters